import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $HistoryLineCustomerComment = styled.span`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('normal')};
  @media ${media.maxWidth.xs} {
    margin-left: 0;
  }
  width: 100%;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const $Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing('xxl')};
  @media ${media.maxWidth.xs} {
    flex-direction: column;
    margin-left: 0;
  }
  width: 100%;
`;
